// Keep stored role values stable. Mirror this catalog in all three clients.
const USER_ROLES = Object.freeze({
  "sup_admin": "sup_admin",
  "sub_admin": "sub_admin",
  "sr_manager": "sr_manager",
  "manager": "manager",
  "assistant_manager": "assistant_manager",
  "team_lead": "team_lead",
  "agent": "agent",
  "projector_viewer": "projector_viewer",
  "hr": "hr",
  "contentCreator": "contentCreator",
  "seo": "seo",
  "account": "account",
  "collection": "collection",
  "front_office": "front_office",
  "engineer": "engineer",
  "developer": "developer",
  "marketing": "marketing",
  "office_admin": "office_admin",
  "pnl": "pnl"
});
const ROLE_LABELS = Object.freeze({
  "sup_admin": "Super Admin",
  "sub_admin": "Director",
  "sr_manager": "PNL",
  "manager": "Manager",
  "assistant_manager": "Assistant Manager",
  "team_lead": "Team Lead",
  "agent": "Agent",
  "projector_viewer": "Projector Viewer",
  "hr": "HR",
  "contentCreator": "Content Creator",
  "seo": "Digital Marketer",
  "account": "Account",
  "collection": "Collection",
  "front_office": "Front Office",
  "engineer": "Engineer",
  "developer": "Developer",
  "marketing": "Marketing",
  "office_admin": "Office Admin",
  "pnl": "PNL (Legacy)"
});
const ROLE_VALUES = Object.freeze(Object.values(USER_ROLES));
const ROLE_OPTIONS = Object.freeze(ROLE_VALUES.map(value => Object.freeze({ value, label: ROLE_LABELS[value] })));
// Super Admin remains outside ordinary user creation.
const ASSIGNABLE_ROLE_OPTIONS = Object.freeze(ROLE_OPTIONS.filter(({ value }) => value !== USER_ROLES.sup_admin));
const isValidRole = role => typeof role === "string" && ROLE_VALUES.includes(role);
const canCopyDetails = role => role === USER_ROLES.sup_admin || role === USER_ROLES.sub_admin;
export { USER_ROLES, ROLE_LABELS, ROLE_VALUES, ROLE_OPTIONS, ASSIGNABLE_ROLE_OPTIONS, isValidRole, canCopyDetails };
